module.exports = __webpack_public_path__ + "img/basic-residence-medium.7d043a4b.png";